var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0156 0.859375C14.4805 0.585938 15.082 0.96875 14.9727 1.51562L13.0039 13.3281C12.9492 13.7656 12.4844 14.0117 12.1016 13.8477L8.71094 12.3984L6.96094 14.5312C6.57812 14.9961 5.8125 14.75 5.8125 14.0938V11.8789L12.375 3.86719C12.5117 3.70312 12.293 3.51172 12.1562 3.64844L4.30859 10.5664L1.38281 9.33594C0.890625 9.14453 0.835938 8.43359 1.32812 8.16016L14.0156 0.859375Z",
    fill: "#DDBA73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.7f918bf54c54b5b1b4b3693e0e91ca85.svg";
export { ForwardRef as ReactComponent };